var map = {
	"./Dragonewt.png": 4093,
	"./Dwarf.png": 5214,
	"./Elf.png": 3354,
	"./Fairy.png": 9980,
	"./Human.png": 4762,
	"./bg.jpg": 5917,
	"./bg_sp.jpg": 8495,
	"./icon_fb.png": 3375,
	"./icon_fb.webp": 147,
	"./icon_switch.png": 3082,
	"./icon_switch.webp": 618,
	"./icon_twitter.png": 6006,
	"./icon_twitter.webp": 6912,
	"./logo_mebius.png": 3978,
	"./logo_mebius.webp": 7639,
	"./s00.png": 2153,
	"./s01.png": 6817,
	"./s02.png": 6591,
	"./s03.png": 1734,
	"./s04.png": 482,
	"./s05.png": 8800,
	"./shareimg.png": 3402,
	"./shokai.png": 2603,
	"./ss_st.jpg": 1409,
	"./starfish_logo.png": 9380,
	"./starfish_logo.webp": 6718,
	"./store1983.png": 5073,
	"./store_amazon.png": 4856,
	"./store_nowprinting.png": 2881,
	"./store_stella.png": 5891,
	"./store_stellaset.png": 8695,
	"./titlelogo.png": 9849,
	"./titlelogo.webp": 3303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;